import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect
} from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Radio,
  notification,
  Select,
} from "antd";
import { useSelector } from 'react-redux';
import UserAPI from '../../../restAPI/UserAPI';
import validationRules from '../../../assets/validation/rules';
import validateForm from '../../../utils/FormValidation';

const Context = React.createContext({
  name: "Default",
});

const StepForm = forwardRef(({ onRefresh }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector(state => state.auth);
  const [userTypes, setUserTypes] = useState([]);
  const [isGetUserTypes, setIsGetUserTypes] = useState(true);
  const [payload, setPayload] = useState({
    "_id": "",
    "firstName": "",
    "lastName": "",
    "email": "",
    "roleId": "",
    "groupId": localStorage.getItem('groupId'),
    "companyId": localStorage.getItem('companyId'),
    "status": 1
  });
  const [errors, setErrors] = useState({});

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
  });
  };

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openViewDrawer: () => {
      setPayload({_id: ref.id});
      getUserById(ref.id);
      setVisible(true); // Open drawer
    },
    closeViewDrawer: () => {
      setVisible(false); // Close drawer
      if (onRefresh) onRefresh(); // Trigger refresh on close
    },
  }));

  const getUserById = async (id) => {   
    await UserAPI.getUserById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          let status = 1;
          if(res.data.status){
            status = 1;
          }
          else{
            status = 0;
          }
          setPayload({
            "_id": res.data._id,
            "firstName": res.data.firstName,
            "lastName": res.data.lastName,
            "email": res.data.email,
            "roleId": res.data.role.id,
            "groupId": res.data.groupId,
            "companyId": res.data.companyId,
            "status": status
          });
          //console.log(JSON.stringify(res.data.status));
        }
    }).catch(err => {
        console.log("error getting group data :", err.message);
    })
  };

  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  const onClose = () => {
    setVisible(false);
    if (onRefresh) onRefresh(); // Trigger refresh on drawer close
    setPayload({
      "_id": "",
      "firstName": "",
      "lastName": "",
      "email": "",
      "roleId": "",
      "groupId": localStorage.getItem('groupId'),
      "companyId": localStorage.getItem('companyId'),
      "status": 1
    });
    setErrors({});
  } 

  useEffect(() => {
    if(isGetUserTypes){
      getAllUserTypes();
      setIsGetUserTypes(false);
    }
  });

  const getAllUserTypes = async () => {   
    await UserAPI.getAllUserTypes(token, localStorage.getItem('groupId'),  localStorage.getItem('companyId')).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) =>  {
              rows.push({value: rowValue._id, label: rowValue.name})
          });
          setUserTypes(rows);

        }
    }).catch(err => {
        console.log("error getting contry codes data :", err.message);
    })
  };

  const OnUserTypeChange = (value) => {
    setPayload({
      "_id": payload._id,
      "firstName": payload.firstName,
      "lastName": payload.lastName,
      "email": payload.email,
      "roleId": value,
      "groupId": payload.groupId,
      "companyId": payload.companyId,
      "status": payload.status
    });
  }

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
        const err = validationResult.errors
        const newErrors = {};
        Object.keys(err).forEach((value) => {
            newErrors[value] = err[value];
        })
        setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
        const keyData = Object.keys(data)[0]
        setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
  }

  const onRadioChange = (e) => {
    setPayload({
      "_id": payload._id,
      "firstName": payload.firstName,
      "lastName": payload.lastName,
      "email": payload.email,
      "roleId": payload.roleId,
      "groupId": payload.groupId,
      "companyId": payload.companyId,
      "status": e.target.value
    });
  };

  const onSubmit = async () => {
    if(localStorage.getItem('groupId') === null){
      openNotificationWithIcon('error', 'User update failed', 'Please select the group', 'bottomLeft');
    }else{
      if(localStorage.getItem('companyId') === null){
        openNotificationWithIcon('error', 'User update failed', 'Please select the company', 'bottomLeft');
      }
      else{
          const formData = {
            "firstName": payload.firstName,
            "lastName": payload.lastName,
            "email": payload.email,
            "roleId": payload.roleId,
            "groupId": localStorage.getItem('groupId'),
            "companyId": localStorage.getItem('companyId'),
            "status": payload.status
          };

          await UserAPI.updateUser(token, localStorage.getItem('groupId'),  localStorage.getItem('companyId'), payload._id, formData)
          .then((response) => {
              //console.log(response);
              onClose();
              openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
          })
          .catch((err) => {
              if (err.response) {
                  openNotificationWithIcon('error', 'User update failed', `${err.response.data.message}`, 'bottomLeft');
              } else {
                  openNotificationWithIcon('error', 'User update failed', `${err.message}`, 'bottomLeft');
              }
          });
      }
    }
  }

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="View User"
        width={700}
        visible={visible}
        onClose={onClose}
        footer={
          <div style={{ textAlign: "right" }}>
            {/* <Button style={{ marginRight: 8 }} size="large" onClick={onClearChange}>
              Close
            </Button> */}

            <Button
              type="primary"
              size="large"
              hidden
              onClick={onSubmit}
            >
              Submit
            </Button>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          <Form layout="vertical">
            {/* <Alert message="* Fields are required" type="warning" /> */}
            <Form.Item label="First Name" validateStatus={errors.userFirstName ? 'error' : ''} help={errors.userFirstName || ''} required>
              <Input size="large" disabled name="firstName" value={payload["firstName"]} onChange={(e) => { setPayload(prev => ({...prev, firstName: e.target.value})); const validateData = {userFirstName: e.target.value}; validateFormData(validateData); }}/>
            </Form.Item>

            <Form.Item label="Last Name" validateStatus={errors.userLastName ? 'error' : ''} help={errors.userLastName || ''} required>
              <Input size="large" disabled name="lastName" value={payload["lastName"]} onChange={(e) => { setPayload(prev => ({...prev, lastName: e.target.value})); const validateData = {userLastName: e.target.value}; validateFormData(validateData); }}/>
            </Form.Item>

            
            <Form.Item label="Email Address" validateStatus={errors.email ? 'error' : ''} help={errors.email || ''} required>
              <Input size="large" disabled name="email" value={payload["email"]} onChange={(e) => { setPayload(prev => ({...prev, email: e.target.value})); const validateData = {email: e.target.value}; validateFormData(validateData); }}/>
            </Form.Item>

            <Form.Item
              label="User Type" required >
              <Select
                showSearch
                disabled
                name="state"
                optionFilterProp="label"
                value={payload["roleId"]}
                size="large"
                onChange={OnUserTypeChange}
                options={userTypes}
              />
            </Form.Item>
            <Form.Item label="Status" required>
              <Radio.Group name="status" disabled value={payload["status"]} onChange={onRadioChange}>
                <Radio value={1}>Active</Radio>
                <Radio value={0}>Inactive</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
